/**
 * The counter id, or null when Metrika must stay off. It runs only in a production build
 * that sets VITE_YM_COUNTER_ID (the prod server build, see docs/DEPLOY_STEPS.md), never in
 * `npm run dev`, tests or a local `vite build` without it.
 */
function counterId(): number | null {
  if (!import.meta.env.PROD) return null;
  const raw = import.meta.env.VITE_YM_COUNTER_ID?.trim() ?? '';
  return /^[1-9][0-9]*$/.test(raw) ? Number(raw) : null;
}

function loadScript(id: number): void {
  const src = `https://mc.yandex.ru/metrika/tag.js?id=${id}`;
  if (Array.from(document.scripts).some((script) => script.src === src)) return;

  window.ym =
    window.ym ||
    function (...args: unknown[]) {
      (window.ym!.a = window.ym!.a || []).push(args);
    };
  window.ym.l = Date.now();

  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
}

export function initYandexMetrika(): void {
  const id = counterId();
  if (id === null) return;

  loadScript(id);
  window.ym?.(id, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

export function trackPageView(url: string): void {
  const id = counterId();
  if (id === null) return;
  window.ym?.(id, 'hit', url);
}
